import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

/** Shared row layout; each service owns its connection actions and expanded content.
 *  The dot beside the name is the single-choice Primary selector; availability is the row's status text. */
@Component({
  selector: 'app-service-provider-row',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './service-provider-row.component.html',
  styleUrls: ['./service-provider-row.component.css'],
})
export class ServiceProviderRowComponent {
  @Input() name = '';
  @Input() description = '';
  @Input() comingSoon = false;
  @Input() divided = true;
  /** Whether this provider is Primary; null shows no selector. */
  @Input() selected: boolean | null = null;
  /** An available provider that is not Primary can be chosen. */
  @Input() selectable = false;
  @Output() readonly select = new EventEmitter<void>();
}
